module.exports = __webpack_public_path__ + "static/media/background.8a1bc0c2.jpg";